<template>
    <modal :name="name" :scrollable="true" :clickToClose="false" height="auto" :width="520" class="topz"
        styles="border-radius: 16px; overflow: hidden;">
        <!-- Header -->
        <div class="modal-header">
            <span class="modal-title">Run Model</span>
            <button class="close-btn" @click="handleCloseModal">&#x2715;</button>
        </div>

        <!-- Body -->
        <div class="modal-body">

            <!-- Section 1 -->
            <div v-if="modelType === 'daycent'" class="section">
                <p class="section-title">
                    Please select the option you want to use to run the daycent model.
                </p>
                <div class="radio-pill-group">
                    <label v-for="(option, idx) in dayCentModelTypes" :key="`daycent-${idx}`" class="radio-pill"
                        :class="{ selected: dayCentModelType && dayCentModelType.value === option.value }">
                        <input type="radio" :value="option" v-model="dayCentModelType" hidden />
                        <span class="radio-dot"
                            :class="{ active: dayCentModelType && dayCentModelType.value === option.value }"></span>
                        {{ option.name }}
                    </label>
                </div>
            </div>

            <!-- Section 2 -->
            <div v-if="modelType === 'mems'" class="section">
                <p class="section-title">
                    Please select the option you want to use to run the memes model.
                </p>
                <div class="radio-pill-group">
                    <label v-for="(option, idx) in dayCentModelTypes" :key="`daycent-${idx}`" class="radio-pill"
                        :class="{ selected: dayCentModelType && dayCentModelType.value === option.value }">
                        <input type="radio" :value="option" v-model="dayCentModelType" hidden />
                        <span class="radio-dot"
                            :class="{ active: dayCentModelType && dayCentModelType.value === option.value }"></span>
                        {{ option.name }}
                    </label>
                </div>
            </div>

            <!-- Section 3 -->
            <div v-if="modelType === 'enteric'" class="section">
                <p class="section-title">
                    Please select the option you want to use to run the Enteric Methane model.
                </p>
                <div class="radio-pill-group">
                    <label v-for="(option, idx) in entericModelTypes" :key="`enteric-${idx}`" class="radio-pill"
                        :class="{ selected: entericModelType && entericModelType.value === option.value }">
                        <input type="radio" :value="option" v-model="entericModelType" hidden />
                        <span class="radio-dot"
                            :class="{ active: entericModelType && entericModelType.value === option.value }"></span>
                        {{ option.name }}
                    </label>

                    <div :style="{ width: '370px' }">
                        <v-select
                            :rounded="true"
                            outlined
                            dense
                            label="Select Year"
                            v-model="selectedYearValue"
                            :items="yearOptions"
                        ></v-select>
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
            <button class="btn-cancel" @click="handleCloseModal">Cancel</button>
            <button class="btn-confirm" @click="setRunModelType">Confirm</button>
        </div>

    </modal>
</template>

<script>
export default {
    props: ["modelType"],

    data: () => ({
        name: "RunModelConfirmation",
        dayCentModelTypes: [
            { name: "Pasture wise", value: 1 },
            { name: "Paddock wise", value: 2 },
        ],
        entericModelTypes: [
            { name: "Tier 1", value: "ipcc_tier1" },
            { name: "Tier 2", value: "ipcc_tier2" },
        ],
        dayCentModelType: null,
        entericModelType: null,
        selectedYearValue: Number(localStorage.getItem("arvaYear")) || null,
        yearOptions: Array.from({ length: 13 }, (_, i) => 2015 + i)
    }),

    methods: {
        handleCloseModal() {
            this.$emit("close-template-modal")
            this.hide()
        },

        setRunModelType() {
            // const dataObj = modelType === 'mems' || modelType === 'daycent' ?{ dayCentModelType: this.dayCentModelType } : { entericModelType: this.entericModelType }
            let dataObj;

            switch (this.modelType) {
                case 'mems':
                    dataObj = { dayCentModelType: this.dayCentModelType }
                    break;

                case 'daycent':
                    dataObj = { dayCentModelType: this.dayCentModelType }
                    break;

                case 'enteric':
                    dataObj = {
                        entericModelType: this.entericModelType,
                        year: this.selectedYearValue
                    }
                    break;
            
                default:
                    break;
            }

            this.$emit("set-run-model-type", dataObj);
        },

        show() {
            this.$modal.show(this.name)
        },

        hide() {
            this.$modal.hide(this.name)
        },
    },

    mounted() {
        this.$modal.show(this.name)
    },
}
</script>

<style scoped>
/* ── z-index ── */
.topz {
    z-index: 9999;
}

/* ── Header ── */
.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px 16px 24px;
    border-bottom: 1px solid #e9ecef;
    background: #ffffff;
}

.modal-title {
    font-size: 17px;
    font-weight: 600;
    color: #1a1a1a;
}

.close-btn {
    background: none;
    border: none;
    font-size: 17px;
    color: #6b7280;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s;
}

.close-btn:hover {
    color: #111827;
}

/* ── Body ── */
.modal-body {
    padding: 0;
    background: #ffffff;
}

.section {
    padding: 22px 24px 24px;
}

.section-title {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
    line-height: 1.55;
    margin: 0 0 18px 0;
}

.divider {
    border: none;
    border-top: 1px solid #e9ecef;
    margin: 0;
}

.radio-pill-group {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.radio-pill {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 9px 22px;
    border: 1.5px solid #d1d5db;
    border-radius: 999px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    background: #ffffff;
    transition: border-color 0.15s ease, background 0.15s ease;
    user-select: none;
    width: 180px;
}

.radio-pill:hover {
    border-color: #9ca3af;
}

.radio-pill.selected {
    border-color: #9ca3af;
    background: #f9fafb;
    color: #111827;
}

.radio-dot {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1.5px solid #d1d5db;
    background: #fff;
    flex-shrink: 0;
    position: relative;
    transition: border-color 0.15s ease;
}

.radio-dot.active {
    border-color: #6b7280;
}

.radio-dot.active::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #6b7280;
}

/* ── Footer ── */
.modal-footer {
    display: flex;
    align-items: center;
    /* justify-content: center; */
    gap: 14px;
    padding: 16px 24px 22px;
    border-top: 1px solid #e9ecef;
    background: #ffffff;
}

.btn-cancel,
.btn-confirm {
    flex: 1;
    max-width: 160px;
    height: 46px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    letter-spacing: 0.01em;
    transition: filter 0.15s ease;
}

.btn-cancel {
    background: #c8ccd2;
    color: #3d4451;
}

.btn-cancel:hover {
    filter: brightness(0.93);
}

.btn-confirm {
    background: #6abf69;
    color: #ffffff;
}

.btn-confirm:hover {
    filter: brightness(0.94);
}
</style>